import React from "react";
import PhotoMap from "./PhotoMap";

function App() {
  return <PhotoMap photoFolder="/media/photos" />;
}

export default App;